import { Injectable } from '@angular/core';
import { GatewayPaymentDataDto } from '@shared/service-proxies/service-proxies';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class GatewayPaymentOrderService {

 public isPaymentSuccessfully$: Subject<boolean> = new Subject<boolean>();

 public isGatewayPaymentSuccessfully$: Subject<GatewayPaymentDataDto> = new Subject<GatewayPaymentDataDto>();

  setIsPaymentSuccessfully(isPaid: boolean): void {
   this.isPaymentSuccessfully$.next(isPaid);
  }

  setIsGatewayPaymentSuccessfully(paymentData: GatewayPaymentDataDto): void {
    console.log("GatewayPaymentOrderService - setIsGatewayPaymentSuccessfully", paymentData);
   this.isGatewayPaymentSuccessfully$.next(paymentData);
  }
}
